import { LocalDeliveryEndpoints } from '@/modules/preference/local-delivery/api/localDeliveryEndpoints'

/**
 * Local Delivery endpoint instance
 * instantiate localDelivery api class with a different api path
 */
export const localDeliveryEndpoints = new LocalDeliveryEndpoints()
